import type {
  OnboardingTourStepOption,
  SupportedOnboardingTourStep,
  UpdateOnboardingTourStepOptionHandler,
} from 'models';
import { useEffect } from 'react';

export const useInitialStepEffect = ({
  onChangeStep,
  step,
  supportedSteps,
}: {
  onChangeStep: UpdateOnboardingTourStepOptionHandler;
  step?: OnboardingTourStepOption;
  supportedSteps: SupportedOnboardingTourStep[];
}) => {
  useEffect(() => {
    if (step === undefined) {
      const hasSomeCompletedStep = supportedSteps.some((supportedStep) => supportedStep.data.status === 'completed');
      const firstUncompletedStep = supportedSteps.find((supportedStep) => supportedStep.data.status === 'pending');

      if (hasSomeCompletedStep) {
        if (firstUncompletedStep) {
          // TODO: When validate Email is done, is this step still uncompleted?
          onChangeStep({ replace: true, step: firstUncompletedStep.step });
        } else {
          onChangeStep({ replace: true, step: 'finish' });
        }
      } else {
        onChangeStep({ replace: true, step: 'intro' });
      }
    }
  }, [onChangeStep, step, supportedSteps]);
};
